import {
	BackdropCircularProgress,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import { BasicPaymentRecordHeaderColumnsForView, HeaderRecordHeaderColumns, TrailerRecordHeaderColumns } from "../CollectionUploadedParser/VaidationParserHeaderColumns";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BasicPaymentRecordViewDataGrid } from "./panels/BasicPaymentRecordViewDataGrid";
import { HeaderRecordViewDataGrid } from "./panels/HeaderRecordViewDataGrid";
import { IAppState } from "../../../../store/reducers";
import { IGetListRequest } from "../../../../models";
import {
	INITIAL_SNACKBAR_DATA,
} from "../../../../common/constants";
import { TrailerRecordViewDataGrid } from "./panels/TrailerRecordViewDataGrid";
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";

import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions";
import { useNavigateToLogout } from "../../../../common/Common";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

export interface ICollectionUploadedViewSetup { }
const COLLECTION_UPLOADED_TRANSACTIONS_VIEW_QUERY_KEY = "collection-uploaded-transaction-view-list";

const useCollectionUploadedTransactionsView = (
	id: string | undefined,
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			COLLECTION_UPLOADED_TRANSACTIONS_VIEW_QUERY_KEY,
			id,
			params,
		],
		queryFn: () =>
			TransactionsServices.getCollectionUploadedTransacitonsViewList(
				id,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});

export const CollectionUploadedView: React.FC<ICollectionUploadedViewSetup> = () => {
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);
	const [collectionUploadedViewData, setCollectionUploadedViewData] = useState<any>(undefined);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);



	const { isPending, data } = useCollectionUploadedTransactionsView(
		editRecordId,
		queryParams,
		navigateToLogout
	);
	const CollectionUploadedViewList: any | null = data;

	useEffect(() => {
		if (CollectionUploadedViewList) {
			setCollectionUploadedViewData(CollectionUploadedViewList);
		}
	}, [CollectionUploadedViewList]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};


	const expandedLabels = ["Transactions", "Collection"];
	const expandedCollectionUploadedViewOrSetupItem = "Collection Uploaded";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Collection" &&
				item.label === expandedCollectionUploadedViewOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCollectionUploadedViewOrSetupItem && "/direct-deposit/transactions/collection-uploaded",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",

				}}
			>
				{"File Details"}
			</div>
			<BackdropCircularProgress
				open={isPending}
				testId="file-details"
			/>
			<HeaderRecordViewDataGrid
				columns={HeaderRecordHeaderColumns}
				rows={
					collectionUploadedViewData && collectionUploadedViewData.header
						? collectionUploadedViewData.header
						: []
				}
				showIndexColumn={false}
				showChecboxColumn={false}
				pageTitle={"Header Record"}
			/>

			<BasicPaymentRecordViewDataGrid
				columns={BasicPaymentRecordHeaderColumnsForView}
				rows={collectionUploadedViewData && collectionUploadedViewData.paymentRecord
					? collectionUploadedViewData.paymentRecord
					: []}
				showIndexColumn={false}
				showChecboxColumn={false}
				pageTitle={"Basic Payment Record"}
			/>

			<TrailerRecordViewDataGrid
				columns={TrailerRecordHeaderColumns}
				rows={
					collectionUploadedViewData && collectionUploadedViewData.trailer
						? collectionUploadedViewData.trailer
						: []
				}
				showIndexColumn={false}
				showChecboxColumn={false}
				pageTitle={"Trailer Record"}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"file-details"}
				open={snackbarData.open}
			/>
		</>
	);
};
